import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { URL_SERVICIOS } from "../../config/url";
import 'rxjs/add/operator/map';

@Injectable()
export class UsuarioProvider {

  constructor(private http: Http) {
    
  }

  buscar(identificacion):Promise<any>{
    return new Promise((resolve, reject) => {
      let url = URL_SERVICIOS + "usuario/buscar/" + identificacion;
      this.http.get(url)
      .map(resp => resp.json())
      .subscribe(data => {
        if(data.error){
          reject(data);
        }else{
          resolve(data);
        }
      },
      error => {
        console.error(error);
        reject(error);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/usuario/usuario.ts